<template>
  <div class="departments">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Employee Salary Prorations</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>

                  <li class="breadcrumb-item active">Salary</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <!-- Search Filter -->
          <div class="row filter-row">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterEmpId"
                  @keyup="searchempcode"
                  style="height: 55px !important"
                />
                <label class="focus-label">Employee Code</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input
                  type="text"
                  class="form-control floating"
                  v-model="filterEmpName"
                  @keyup="searchTable"
                  style="height: 55px !important"
                />
                <label class="focus-label">Search Employee</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <a @click="getFilter" class="btn btn-success btn-block">
                Search
              </a>
            </div>
          </div>
          <!-- /Search Filter -->

          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div>
                <v-data-table
                  :headers="headers"
                  :items="salaries"
                  sort-by="name"
                  class="elevation-1"
                >
                  <template v-slot:[`item.check`]="{ item }">
                    <router-link
                      :to="{
                        name: 'salaryEmployeeItem',
                        params: { id: item.employee.id }
                      }"
                      >Check Salary</router-link
                    >
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link
                        :to="{
                          name: 'salaryEmployeeItem',
                          params: { id: item.employee.id }
                        }"
                        class="avatar"
                        ><img
                          alt=""
                          src="~@/assets/profiles/avatar-02.jpg"
                          v-if="!item.employee.passportPhoto"/>
                        <img
                          alt=""
                          :src="item.employee.passportPhoto"
                          width="38"
                          v-if="item.employee.passportPhoto"
                      /></router-link>
                      <router-link
                        :to="{
                          name: 'salaryEmployeeItem',
                          params: { id: item.employee.id }
                        }"
                        >{{
                          `${item.employee.firstName} ${item.employee.lastName}`
                        }}</router-link
                      >
                    </h2>
                  </template>
                  <template v-slot:[`item.Employee.employeeCode`]="{ item }">
                    {{ item.employee.employeeCode }}
                  </template>
                  <template v-slot:[`item.monthDays`]="{ item }">
                    {{ item.noOfDayInMonth }}
                  </template>
                  <template v-slot:[`item.period`]="{ item }">
                    {{ setMonth(new Date(item.createdOn).getMonth()) +', ' + new Date().getFullYear()  }}
                  </template>
                  <template v-slot:[`item.workDays`]="{ item }">
                    {{ item.noOfWorkedDay }}
                  </template>
                  <template v-slot:[`item.unpaidDays`]="{ item }">
                    {{ item.noOfDayInMonth - item.noOfWorkedDay }}
                  </template>
                  <template v-slot:[`item.clear`]="{ item }">
                    <a
                      class="dropdown-item"
                      @click="openDialogClearProration(item)"
                      ><i class="fa fa-trash-o m-r-5"></i> Clear</a
                    >
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Clear Proration -->
        <v-dialog v-model="dialogClear" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Remove Salary Proration</h3>
                <p>Are you sure want to remove salary proration?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      v-if="!loading"
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      @click.prevent="removeSalaryProrated"
                      data-dismiss="modal"
                      >Clear</a
                    >
                    <a
                      v-if="loading"
                      disabled
                      class="btn btn-primary continue-btn"
                      >Loading...</a
                    >
                  </div>
                  <div class="col-6">
                    <a @click="closeDialogClearProration" class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>

        <!-- Add Department Modal -->

        <v-dialog v-model="dialog" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Salary</h5>
              <button type="button" class="close" @click="close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>Employee <span class="text-danger">*</span></label>

                  <multiselectvue
                    class="from-control"
                    v-model="employeeNameAdd"
                    placeholder="Select Employee"
                    :custom-label="nameOfEmployeeAdd"
                    :options="employees"
                    :searchable="true"
                    @select="optionSelectedAdd"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"
                      >{{ option.firstName }} {{ option.lastName }}</template
                    >
                  </multiselectvue>

                  <!-- <select class="form-control" v-model="employeeId">
                      <option disabled>Select Staff</option>
                      <option
                        v-for="member in employees"
                        :key="member.id"
                        :value="member.id"
                      >
                        {{ member.lastName + " " + member.firstName }}
                      </option>
                    </select> -->

                  <!-- <input class="form-control" type="text" v-model="departmentName" > -->
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onSubmit"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                    :disabled="submitted"
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>

        <v-dialog v-model="dialogCopyFrom" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Copy From Employee</h5>
              <button type="button" class="close" @click="closeCopyFrom">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label
                    >From Employee <span class="text-danger">*</span></label
                  >

                  <multiselectvue
                    class="from-control"
                    v-model="employeeName"
                    placeholder="Select Employee"
                    :custom-label="nameOfEmployee"
                    :options="groups"
                    :searchable="true"
                    @select="optionSelected"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"
                      >{{ option.Employee.firstName }}
                      {{ option.Employee.lastName }}</template
                    >
                  </multiselectvue>
                </div>
                <div class="form-group leave-duallist">
                  <label>To Employee(s)</label>
                  <div class="col-sm-6 col-md-6">
                    <div class="form-group form-focus">
                      <input
                        type="text"
                        class="form-control floating"
                        v-model="filterToEmployee"
                        style="height: 55px !important"
                      />
                      <label class="focus-label">Search Employee</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="fromEmployee_select"
                        v-model="pickEmployees"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      >
                        <option
                          :value="item.id"
                          v-for="item in searchToGroup"
                          :key="item.id"
                          >{{ item.firstName + " " + item.lastName }}
                        </option>
                      </select>
                    </div>
                    <div class="multiselect-controls col-lg-2 col-sm-2">
                      <button
                        type="button"
                        id="fromEmployee_select_rightAll"
                        @click="selectedEmployeeAllFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-forward"></i>
                      </button>
                      <button
                        type="button"
                        id="fromEmployee_select_rightSelected"
                        @click="selectedEmployeeFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button
                        type="button"
                        id="fromEmployee_select_leftSelected"
                        @click="selectedEmployeeTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button
                        type="button"
                        id="fromEmployee_select_leftAll"
                        @click="selectedEmployeeAllTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-backward"></i>
                      </button>
                    </div>
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="fromEmployee_select_to"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      ></select>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onCopyFrom"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>

        <v-dialog v-model="dialogGSlip" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Generate Payslip</h5>
              <button type="button" class="close" @click="closeGSlip">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="col-md-12">
                <div
                  class="alert alert-danger alert-dismissible fade show"
                  role="alert"
                  v-if="error"
                >
                  <strong>Error!</strong> {{ error }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <div
                  class="alert alert-success alert-dismissible fade show"
                  role="alert"
                  v-if="message"
                >
                  <strong>Success!</strong> {{ message }}
                  <button
                    type="button"
                    class="close"
                    data-dismiss="alert"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>
              <form>
                <div class="form-group">
                  <label>Period Month <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="periodMonth">
                    <option disabled>Select Month</option>
                    <option>January</option>
                    <option>February</option>
                    <option>March</option>
                    <option>April</option>
                    <option>May</option>
                    <option>June</option>
                    <option>July</option>
                    <option>August</option>
                    <option>September</option>
                    <option>October</option>
                    <option>November</option>
                    <option>December</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Period Year <span class="text-danger">*</span></label>
                  <select class="form-control" v-model="periodYear">
                    <option disabled>Select Year</option>
                    <option v-for="year in years" :key="year" :value="year">
                      {{ year }}
                    </option>
                  </select>
                </div>
                <div class="form-group">
                  <label
                    >Generate for All Employee Salaries
                    <span class="text-danger">*</span></label
                  >
                  <select class="form-control" v-model="all">
                    <option disabled>Select Option</option>
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>
                <div class="form-group leave-duallist" v-if="all == false">
                  <label>For Employee(s)</label>
                  <div class="row">
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="SPayslip_select"
                        v-model="pickEmployees"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      >
                        <option
                          :value="item.Employee.id"
                          v-for="item in groups"
                          :key="item.Employee.id"
                          >{{
                            item.Employee.firstName +
                              " " +
                              item.Employee.lastName
                          }}
                        </option>
                      </select>
                    </div>
                    <div class="multiselect-controls col-lg-2 col-sm-2">
                      <button
                        type="button"
                        id="SPayslip_select_rightAll"
                        @click="selectedSlipAllFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-forward"></i>
                      </button>
                      <button
                        type="button"
                        id="SPayslip_select_rightSelected"
                        @click="selectedSlipFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button
                        type="button"
                        id="SPayslip_select_leftSelected"
                        @click="selectedSlipTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button
                        type="button"
                        id="SPayslip_select_leftAll"
                        @click="selectedSlipAllTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-backward"></i>
                      </button>
                    </div>
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="SPayslip_select_to"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      ></select>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="generateSlip"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- Delete Employee Modal -->
        <!-- /Delete Employee Modal -->

        <v-dialog v-model="dialogGroupFrom" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Copy From Group</h5>
              <button type="button" class="close" @click="closeGroupFrom">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>From Group <span class="text-danger">*</span></label>
                  <multiselectvue
                    class="from-control"
                    v-model="salaryGroupSelect"
                    placeholder="Select Salary Group"
                    :custom-label="nameOfSalaryGroup"
                    :options="salaryGroups"
                    :searchable="true"
                    @select="optionSelectedSalaryGroup"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"
                      >{{ option.name }}
                    </template>
                  </multiselectvue>
                </div>
                <div class="form-group leave-duallist">
                  <label>To Employee(s)</label>
                  <div class="col-sm-6 col-md-6">
                    <div class="form-group form-focus">
                      <input
                        type="text"
                        class="form-control floating"
                        v-model="filterToSalaryGroup"
                        style="height: 55px !important"
                      />
                      <label class="focus-label">Search Employee</label>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="fromGroup_select"
                        v-model="pickEmployees"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      >
                        <option
                          :value="item.id"
                          v-for="item in sortedEmployeeNames"
                          :key="item.id"
                          >{{ item.firstName + " " + item.lastName }}
                        </option>
                      </select>
                    </div>
                    <div class="multiselect-controls col-lg-2 col-sm-2">
                      <button
                        type="button"
                        id="fromGroup_select_rightAll"
                        @click="selectedGroupAllFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-forward"></i>
                      </button>
                      <button
                        type="button"
                        id="fromGroup_select_rightSelected"
                        @click="selectedGroupFrom"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-right"></i>
                      </button>
                      <button
                        type="button"
                        id="fromGroup_select_leftSelected"
                        @click="selectedGroupTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-chevron-left"></i>
                      </button>
                      <button
                        type="button"
                        id="fromGroup_select_leftAll"
                        @click="selectedGroupAllTo"
                        class="btn btn-block btn-white"
                      >
                        <i class="fa fa-backward"></i>
                      </button>
                    </div>
                    <div class="col-lg-5 col-sm-5">
                      <select
                        id="fromGroup_select_to"
                        class="form-control"
                        size="8"
                        multiple="multiple"
                      ></select>
                    </div>
                  </div>
                </div>
                <div class="submit-section">
                  <button
                    @click.prevent="onGroupFrom"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Department Modal -->

        <v-dialog v-model="dialogUpdateFromGroup" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Update From Group</h5>
              <button type="button" class="close" @click="closeUpdateFromGroup">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form>
                <div class="form-group">
                  <label>From Group <span class="text-danger">*</span></label>
                  <multiselectvue
                    class="from-control"
                    v-model="salaryGroupSelect"
                    placeholder="Select Salary Group"
                    :custom-label="nameOfSalaryGroup"
                    :options="salaryGroups"
                    :searchable="true"
                    @select="optionSelectedSalaryGroup"
                    :allow-empty="false"
                  >
                    <template slot="singleLabel" slot-scope="{ option }"
                      >{{ option.name }}
                    </template>
                  </multiselectvue>
                </div>

                <div class="submit-section">
                  <button
                    @click.prevent="updateFromGroup"
                    class="btn btn-primary submit-btn"
                    data-dismiss="modal"
                  >
                    {{ loading ? "Loading.." : "Submit" }}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </v-dialog>
        <!-- /Add Department Modal -->
        <!-- Delete Department Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Employee Salary</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      @click.prevent="deleteGroup"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a @click="closeDelete" class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Department Modal -->
        <!-- Group payroll model box -->
        <!-- Group payroll model box ends-->
        <!-- Delete Department Modal -->
        <v-dialog v-model="dialogReview" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Review Employee Salary</h3>
                <p>Are you sure want to update all Employee salaries?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      v-if="!loading"
                      href="javascript:void(0);"
                      class="btn btn-primary continue-btn"
                      @click.prevent="reviewSalary"
                      data-dismiss="modal"
                      >Update</a
                    >
                    <a v-if="loading" class="btn btn-primary continue-btn"
                      >Loading...</a
                    >
                  </div>
                  <div class="col-6">
                    <a @click="closeReview" class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Department Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required } from "vuelidate/lib/validators";
import { authenticationService } from "@/services/authenticationService";
import { employeeService } from "@/services/employeeService";
import { organizationService } from "@/services/organizationService";
import { paymentService } from "@/services/paymentService";
import { error } from "jquery";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar
  },
  data() {
    return {
      headers: [
        {
          text: "Employee Name",
          align: "start",
          value: "profile"
        },
        {
          text: "Employee Code",
          value: "Employee.employeeCode",
          sortable: false
        },
        { text: "PERIOD", value: "period", sortable: false },
        { text: "Total Days in Month", value: "monthDays", sortable: false },
        { text: "Total Work Days", value: "workDays", sortable: false },
        { text: "Total Unpaid Days", value: "unpaidDays", sortable: false },
        { text: "", value: "check", sortable: false },
        { text: "", value: "clear", sortable: false }
      ],
      employeeId: "",
      salaries: [],
      prorated: {},
      groups: [],
      salaryGroups: [],
      employees: [],
      group: {},
      fromEmployeeId: null,
      fromGroupId: null,
      pickEmployees: [],
      selectedEmployees: [],
      periodMonth: null,
      periodYear: new Date().getFullYear(),
      all: null,
      submitted: false,
      company: authenticationService.currentOfficeValue,
      loading: false,
      error: "",
      message: "",
      dialog: false,
      dialogReview: false,
      dialogCopyFrom: false,
      dialogGroupFrom: false,
      dialogGSlip: false,
      dialogEdit: false,
      dialogDelete: false,
      dialogClear: false,
      dialogImport: false,
      dialogImportPayroll: false,
      dialogUpdateFromGroup: false,
      file: null,
      fileName: "",
      filterEmpName: "",
      filterEmpId: "",
      filterDesignationId: "",
      nofilterEmployees: [],
      designations: [],
      employeeName: null,
      toEmployee: null,
      filterToEmployee: "",
      salaryGroupSelect: null,
      filterToSalaryGroup: "",
      loading: false,
      employeeNameAdd: null
    };
  },
  validations: {
    name: { required }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogCopyFrom(val) {
      val || this.closeCopyFrom();
    },
    dialogImport(val) {
      val || this.closeImport();
    },
    dialogImportPayroll(val) {
      val || this.closeImportPayroll();
    },
    dialogGroupFrom(val) {
      val || this.closeGroupFrom();
    },
    dialogGSlip(val) {
      val || this.closeGSlip();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogReview(val) {
      val || this.closeReview();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogUpdateFromGroup(val) {
      val || this.closeUpdateFromGroup();
    }
  },
  computed: {
    years: () => {
      var res = [];
      var currentYear = new Date().getFullYear();
      var currentYear = currentYear - 1;
      for (var i = currentYear; i < currentYear + 20; i++) {
        res.push(i);
      }

      return res;
    },

    // searchSalaryList: function() {
    //   return this.groups.filter(d =>
    //     this.filterEmpName != ""
    //       ? d.Employee.firstName
    //           .toLowerCase()
    //           .includes(this.filterEmpName.toLowerCase()) ||
    //         d.Employee.lastName
    //           .toLowerCase()
    //           .includes(this.filterEmpName.toLowerCase()) ||
    //         (d.Employee.employeeCode != null &&
    //           d.Employee.employeeCode
    //             .toLowerCase()
    //             .includes(this.filterEmpName.toLowerCase()))
    //       : true
    //   );
    // },

    sortedEmployeeNames: function() {
      return this.employees.filter(
        d =>
          d.firstName
            .toLowerCase()
            .includes(this.filterToSalaryGroup.toLowerCase()) ||
          d.lastName
            .toLowerCase()
            .includes(this.filterToSalaryGroup.toLowerCase())
      );
    },

    searchToGroup: function() {
      return this.employees.filter(
        d =>
          d.firstName
            .toLowerCase()
            .includes(this.filterToEmployee.toLowerCase()) ||
          d.lastName.toLowerCase().includes(this.filterToEmployee.toLowerCase())
      );
    },

    sortGroup: function() {
      function compare(a, b) {
        if (
          a.Employee.firstName.toLowerCase() <
          b.Employee.firstName.toLowerCase()
        )
          return -1;
        if (
          a.Employee.firstName.toLowerCase() >
          b.Employee.firstName.toLowerCase()
        )
          return 1;
        return 0;
      }

      return this.groups ? this.groups.sort(compare) : this.groups;
    }

    // sortedEmployeeNames: function() {
    //   function compare(a, b) {
    //     if (a.firstName.toLowerCase() < b.firstName.toLowerCase()) return -1;
    //     if (a.firstName.toLowerCase() > b.firstName.toLowerCase()) return 1;
    //     return 0;
    //   }

    //   return this.employees ? this.employees.sort(compare) : this.employees;
    // }
  },

  methods: {
    searchTable() {
      this.salaries = this.nofilterEmployees.filter(
        c =>
          c.employee.firstName
            .toLowerCase()
            .includes(this.filterEmpName.toLowerCase()) ||
          c.employee.lastName
            .toLowerCase()
            .includes(this.filterEmpName.toLowerCase())
      );
    },

    searchempcode() {
      this.salaries = this.nofilterEmployees.filter(c =>
        c.employee.employeeCode
          .toLowerCase()
          .includes(this.filterEmpId.toLowerCase())
      );
    },
    nameOfEmployeeAdd({ firstName, lastName }) {
      return `${firstName} ${lastName}`;
    },

    optionSelectedAdd(option, id) {
      console.log(option.id);
      this.employeeId = option.id;
    },

    nameOfEmployee({ Employee }) {
      return `${Employee.firstName} ${Employee.lastName}`;
    },

    optionSelected(option, id) {
      console.log(option.EmployeeId);
      this.fromEmployeeId = option.EmployeeId;
    },

    nameOfSalaryGroup({ name }) {
      return `${name}`;
    },

    optionSelectedSalaryGroup(option, id) {
      console.log(option.id);
      this.fromGroupId = option.id;
    },

    getFilter() {
      console.log(this.filterEmpId, this.salaries);
      this.salaries = this.nofilterEmployees;
      var employee = [];
      if (this.filterEmpId) {
        this.salaries = this.nofilterEmployees.filter(c =>
          c.employee.employeeCode
            .toLowerCase()
            .includes(this.filterEmpId.toLowerCase())
        );
      } else if (this.filterEmpName) {
        this.salaries = this.nofilterEmployees.filter(
          c =>
            c.employee.firstName
              .toLowerCase()
              .includes(this.filterEmpName.toLowerCase()) ||
            c.employee.lastName
              .toLowerCase()
              .includes(this.filterEmpName.toLowerCase())
        );
      }
      if (!this.filterEmpId && !this.filterEmpName) {
        this.salaries = this.nofilterEmployees;
      }
    },

    clearModel() {
      this.name = "";
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      // console.log(this.fileName)
      this.file = files[0];
    },

    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeImport() {
      this.dialogImport = false;
    },
    closeUpdateFromGroup() {
      this.dialogUpdateFromGroup = false;
    },
    openDialogUpdateFromGroup() {
      this.dialogUpdateFromGroup = true;
    },

    openDialogImportPayroll() {
      this.dialogImportPayroll = true;
    },

    openDialogClearProration(item) {
      this.dialogClear = true;
      this.prorated = item;
    },
    closeDialogClearProration() {
      this.dialogClear = false;
    },

    closeCopyFrom() {
      this.dialogCopyFrom = false;
      this.fromEmployeeId = null;
      this.employeeName = null;
      this.pickEmployees = [];
      this.selectedEmployees = [];
    },

    closeGSlip() {
      this.dialogGSlip = false;
      this.periodMonth = null;
      this.periodYear = new Date().getFullYear();
      this.all = null;
      this.pickEmployees = [];
      this.selectedEmployees = [];
    },

    closeGroupFrom() {
      this.dialogGroupFrom = false;
      this.fromGroupId = null;
      this.salaryGroupSelect = null;
      this.pickEmployees = [];
      this.selectedEmployees = [];
    },
    closeImportPayroll() {
      this.dialogImportPayroll = false;
    },
    openDialog() {
      this.dialog = true;
      this.sortEmployees();
    },
    openDialogImport() {
      this.dialogImport = true;
    },

    openDialogCopyFrom() {
      this.dialogCopyFrom = true;
      this.sortEmployeesFromGroup();
      this.sortEmployees();
    },

    openDialogGSlip() {
      this.dialogGSlip = true;
    },
    openDialogReview() {
      this.dialogReview = true;
    },

    openDialogGroupFrom() {
      this.dialogGroupFrom = true;
      this.sortEmployees();
    },

    closeEdit() {
      this.dialogEdit = false;
    },

    closeDelete() {
      this.dialogDelete = false;
    },
    closeReview() {
      this.dialogReview = false;
    },

    setEdit(model) {
      this.group = model;
      this.dialogEdit = true;
    },

    setDelete(model) {
      this.group = model;
      this.dialogDelete = true;
    },
    selectedSlipAllFrom() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select_to")
        .append(selectOption);
      this.selectedEmployees = this.employees;
    },
    selectedSlipFrom() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select_to")
        .append(selectOption);
      this.selectedEmployees.push(this.pickEmployees[0]);
      // console.log(this.selectedEmployees)
    },
    selectedSlipAllTo() {
      var selectOption = [];
      $(document)
        .find("#SPayslip_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#SPayslip_select")
        .append(selectOption);

      this.selectedEmployees = [];
    },
    selectedSlipTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#SPayslip_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#SPayslip_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedPrograms));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedEmployees = data;
        // console.log(this.selectedEmployees)
      });
    },
    selectedEmployeeAllFrom() {
      var selectOption = [];
      $(document)
        .find("#fromEmployee_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromEmployee_select_to")
        .append(selectOption);
      this.selectedEmployees = this.employees;
    },
    selectedEmployeeFrom() {
      var selectOption = [];
      $(document)
        .find("#fromEmployee_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromEmployee_select_to")
        .append(selectOption);
      this.selectedEmployees.push(...this.pickEmployees);
      // console.log(this.selectedEmployees)
    },
    selectedEmployeeAllTo() {
      var selectOption = [];
      $(document)
        .find("#fromEmployee_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromEmployee_select")
        .append(selectOption);

      this.selectedEmployees = [];
    },
    selectedEmployeeTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#fromEmployee_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#fromEmployee_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedPrograms));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedEmployees = data;
        // console.log(this.selectedEmployees)
      });
    },
    selectedGroupAllFrom() {
      var selectOption = [];
      $(document)
        .find("#fromGroup_select")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromGroup_select_to")
        .append(selectOption);
      this.selectedEmployees = this.employees;
    },
    selectedGroupFrom() {
      console.log(this.pickEmployees);
      var selectOption = [];
      $(document)
        .find("#fromGroup_select")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromGroup_select_to")
        .append(selectOption);
      this.selectedEmployees.push(...this.pickEmployees);
    },
    selectedGroupAllTo() {
      var selectOption = [];
      $(document)
        .find("#fromGroup_select_to")
        .find("option")
        .each(function() {
          selectOption.push(this);
        });

      $(document)
        .find("#fromGroup_select")
        .append(selectOption);

      this.selectedEmployees = [];
    },
    selectedGroupTo() {
      var selectOption = [];
      var values = [];
      $(document)
        .find("#fromGroup_select_to")
        .find("option:selected")
        .each(function() {
          selectOption.push(this);
          values.push($(this).val());
        });

      $(document)
        .find("#fromGroup_select")
        .append(selectOption);

      values.forEach(v => {
        var data = JSON.parse(JSON.stringify(this.selectedPrograms));
        var index = data.indexOf(parseInt(v));
        data.splice(index, 1);
        this.selectedEmployees = data;
        // console.log(this.selectedEmployees)
      });
    },

    getProratedSalaries() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      paymentService.getSalaryProrateds(unit.id).then(
        model => {
          this.salaries = model;
          this.nofilterEmployees = model;
          console.log("prorated", model);
        },
        error => {
          error = error;
        }
      );
    },
    removeSalaryProrated() {
      const id = this.prorated.id;
      this.loading = true
      //console.log(this.resignation);
      paymentService.removeSalaryProrated(id).then(id => {
        this.getProratedSalaries();
        this.closeDialogClearProration();
        alert("Salary proration cleared successfully");
        this.loading = false
      }, error => {
        this.loading = false
        alert("Error clearing salary proration");
      });
    },

    sortEmployees() {
      this.employees.sort(function(a, b) {
        let x = a.firstName.toLowerCase();
        let y = b.firstName.toLowerCase();
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    },

    sortEmployeesFromGroup() {
      this.groups.sort(function(a, b) {
        let x = a.Employee.firstName.toLowerCase();
        let y = b.Employee.firstName.toLowerCase();
        if (x < y) {
          return -1;
        }
        if (x > y) {
          return 1;
        }
        return 0;
      });
    },

    getEmployees() {
      var unit = JSON.parse(localStorage.getItem("companyUnit"));
      employeeService.getEmployees(unit.id).then(
        model => {
          var salaryEmployees = this.groups.map(i => i.EmployeeId);
          this.employees = model.filter(c => !salaryEmployees.includes(c.id));
          // console.log(this.employees);
        },
        error => {
          error = error;
        }
      );
    },

    setMonth(nm) {
      switch(nm){
        case 0:
          'Jan'
          break;
        case 1:
          'Feb'
          break;
        case 2:
          'Mar'
          break;
        case 3:
          'Apr'
          break;
        case 4:
          'May'
          break;
        case 5:
          'Jun'
          break;
        case 6:
          'Jul'
          break;
        case 7:
          'Aug'
          break;
        case 8:
          'Sept'
          break;
        case 9:
          'oct'
          break;
        case 10:
          'nov'
          break;
        case 11:
          'dec'
          break;

      }
    }
  },
  mounted() {
    // Datatable

    // if ($('.datatable').length > 0) {
    //   $('.datatable').DataTable({
    //     "bFilter": false,
    //   });
    // }
    // if ($('.floating').length > 0) {
    //   $('.floating').on('focus blur', function (e) {
    //     $(this).parents('.form-focus').toggleClass('focused', (e.type === 'focus' || this.value.length > 0));
    //   }).trigger('blur');
    // }
    this.getProratedSalaries();
    console.log(this.groups);
  },
  name: "ProratedSalaries"
};
</script>



// WEBPACK FOOTER //
// src/components/payroll/proratedSalaries.vue